import {
  login,
  logout,
  getInfo,
  getSysInfoApi
} from "@/api/login";
import {
  getToken,
  setToken,
  removeToken
} from "@/utils/auth";
import {
  resetRouter
} from "@/router";
import cache from "@/plugins/cache";
const getDefaultState = () => {
  return {
    token: getToken(),
    name: "",
    avatar: "",
  };
};
const user = {
  state: getDefaultState(),
  mutations: {
    RESET_STATE: (state) => {
      Object.assign(state, getDefaultState());
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
      setToken(token)
    },
    SET_USER: (state, val) => {
      cache.session.remove("userInfo");
      cache.session.set("userInfo", JSON.stringify(val));
      state.userInfo = val;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_SYSINFO: (state, sysInfo) => {
      state.sysInfo = sysInfo;
    },
  },
  actions: {
    // user login
    // login({ commit }, userInfo) {
    //   const { username, password } = userInfo
    //   return new Promise((resolve, reject) => {
    //     login({ username: username.trim(), password: password }).then(response => {
    //       const { data } = response
    //       commit('SET_TOKEN', data.token)
    //       setToken(data.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    Login({
      commit
    }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then((res) => {
          setToken(res.token);
          commit("SET_TOKEN", res.token);
          resolve();
        }).catch((error) => {
          console.log(error);
          reject(error);
        });
      });
    },
    // get user info
    getInfo({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        getInfo().then((res) => {
          const user = res.user;
          localStorage.setItem('userinfo', JSON.stringify(user));
          localStorage.setItem('salelandId', user.salesmanId)
          let obj = {
            userId: user.userId,
            name: user.nickName,
            avatar: user.avatar,
          };
          commit("SET_USER", user);
          const avatar = user.avatar == "" || user.avatar == null ? require("@/assets/images/profile.png") :
            process.env.VUE_APP_BASE_API + user.avatar;
          commit("SET_NAME", user.nickName);
          commit("SET_AVATAR", avatar);
          resolve(res);
        }).catch((error) => {
          console.log(error);
          reject(error);
        });
      });
    },
    // user logout
    logout({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          removeToken(); // must remove  token  first
          resetRouter();
          localStorage.removeItem('userinfo')
          commit("RESET_STATE");
          resolve();
        }).catch((error) => {
          reject(error);
        });
      });
    },
    // remove token
    resetToken({
      commit
    }) {
      return new Promise((resolve) => {
        removeToken(); // must remove  token  first
        commit("RESET_STATE");
        resolve();
      });
    },
    getSysInfo({
      commit
    }) {
      return new Promise((resolve, reject) => {
        getSysInfoApi().then((res) => {
          const data = res.data;
          console.log('data', data)
          commit("SET_SYSINFO", data);
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },
  },
};
// export default {
//   namespaced: true,
//   state,
//   mutations,
//   actions
// }
export default user;